<script>
import appConfig from '@/app.config'
import baseMixin from '@/mixins/baseMixin'
import Colours from '@/constants/core/VuetifyColourClass'

export default {
  mixins: [baseMixin],
  props: {
    release: {
      type: Object,
      default: () => {},
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return { ...Colours }
  },
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: appConfig.description }],
    }
  },
  methods: {
    workItemIcon(workItemType) {
      const iconMap = {
        Feature: { icon: 'mdi-star', colour: this.orange },
        Epic: { icon: 'mdi-layers', colour: this.teal },
        Task: { icon: 'mdi-wrench', colour: this.blue },
        Bug: { icon: 'mdi-bug', colour: this.deepOrange },
        Issue: { icon: 'mdi-bug', colour: this.deepOrange },
        Requirement: { icon: 'mdi-lead-pencil', colour: this.green },
        Default: { icon: 'mdi-collage', colour: this.lightGreen },
      }

      return iconMap[workItemType] || iconMap.Default
    },
  },
}
</script>

<template>
  <v-row class="pa-2" :class="{ 'mt-8': !embedded }" justify="center">
    <v-col>
      <v-card class="release-card" rounded>
        <div class="release-bg">
          <div class="d-flex justify-end pa-6 release-header">
            <p
              v-if="release.dateCreated"
              class="font-weight-bold white--text"
              >{{ release.releaseId }}</p
            >
          </div>
          <div class="d-flex justify-space-between px-6 pt-8">
            <h1 class="mb-8">Release Notes</h1>
          </div>
        </div>
        <div class="release-content">
          <div
            v-for="wi in release.releaseData.workItems"
            :key="wi.Id"
            class="d-flex pa-6"
          >
            <div>
              <v-tooltip
                right
                :color="`${workItemIcon(wi.workItemType).colour} darken-2`"
                content-class="icon-tooltip"
              >
                <template v-slot:activator="{ on, attrs }" class="type-tooltip">
                  <v-icon
                    v-bind="attrs"
                    size="32"
                    class="type-icon"
                    :color="workItemIcon(wi.workItemType).colour"
                    v-on="on"
                  >
                    {{ workItemIcon(wi.workItemType).icon }}
                  </v-icon>
                </template>
                <span>{{ wi.workItemType }}</span>
              </v-tooltip>
            </div>

            <div class="ml-4">
              <h3 class="mb-2">{{ wi.releaseTitle }}</h3>
              <p :class="{ 'pr-16': $vuetify.breakpoint.lgAndUp }">{{
                wi.releaseDescription
              }}</p>
            </div>
          </div>
        </div>

        <div class="pr-section pa-6">
          <p class="mb-4 pr-section-title">
            <span>
              <v-icon class="mb-1" color="black">mdi-source-merge</v-icon></span
            >
            Pull Requests</p
          >
          <div
            v-for="pr in release.releaseData.pullRequests"
            :key="pr.Id"
            class="d-flex"
          >
            <p class="mr-4 mb-0 mt-1 font-weight-bold">
              {{ pr.id }}
            </p>
            <div>
              <p class="mb-1 pr-item-title">
                {{ pr.title }}
              </p>
              <p>{{ pr.description }}</p>
            </div>
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
.pr-section {
  font-size: 14px;
  background-color: rgb(253, 253, 253);

  .pr-section-title {
    font-size: 18px;
    font-weight: bold;
  }

  .pr-item-title {
    font-size: 16px;
    text-decoration: underline;
  }
}

.release-bg {
  background-image: url('../../assets/images/backgrounds/bg_releases.jpg');
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
}

.release-header {
  margin-bottom: 400px;
}

.icon-tooltip {
  opacity: 1;
}

.type-icon {
  cursor: pointer;
}

@media (min-width: 1903px) {
  .release-header {
    margin-bottom: 700px;
  }
}
</style>
